import {TradingState} from "../models/QuoteRecord";

export const TradingStatePipe = "tradingState";

export type TradingStatePipe = (state: TradingState) => string;

export function tradingStatePipe(): TradingStatePipe {
    return (state: TradingState) => {
        switch (state) {
            case TradingState.OPEN:
                return "trading-state.OPEN";
            case TradingState.DASH:
                return "trading-state.DASH"; // TODO WTF is this state
            case TradingState.ADJUST_ON:
                return "trading-state.ADJUST_ON";
            case TradingState.PRE_OPEN:
                return "trading-state.PRE_OPEN";
            case TradingState.SUSPENDED:
                return "trading-state.SUSPENDED";
            case TradingState.CLOSED:
                return "trading-state.CLOSED";
            case TradingState.HALT:
                return "trading-state.HALT";
            case TradingState.PRE_NR:
                return "trading-state.PRE_NR";
            case TradingState.PRE_CSPA:
                return "trading-state.PRE_CSPA";
            case TradingState.OPENING:
                return "trading-state.OPENING";
            case TradingState.INQUIRY_ONLY:
                return "trading-state.INQUIRY_ONLY";
            case TradingState.INQUIRY:
                return "trading-state.INQUIRY";
            case TradingState.ADJUST:
                return "trading-state.ADJUST";
            case TradingState.REG_HALT:
                return "trading-state.REG_HALT";
            case TradingState.WAIT:
                return "trading-state.WAIT";
            case TradingState.MARKET_ON_CLOSE:
                return "trading-state.MARKET_ON_CLOSE";
            default:
                return state;
        }
    };
}
